import { createTrackingData, TrackingBaseData } from '@/api/tracking';
import axios from 'axios';
import {
  PersonalSurveyProfile,
  PersonalSurveyProfileDraft,
  PersonalSurveyProfileInput,
  PersonalSurveyProfileTrackingCategory,
} from '@/types';

export async function fetchPersonalSurveyProfile(): Promise<PersonalSurveyProfile> {
  const { data } = await axios.get<PersonalSurveyProfile>(
    '/personal_survey_profile',
  );
  return data;
}

export async function updatePersonalSurveyProfile(
  profile: PersonalSurveyProfile,
  trackingBaseData?: TrackingBaseData,
  trackingCategory?: PersonalSurveyProfileTrackingCategory,
): Promise<PersonalSurveyProfile> {
  const { data } = await axios.put<PersonalSurveyProfile>(
    '/personal_survey_profile',
    {
      ...profile,
      ...(trackingBaseData
        ? {
            tracking_data: {
              ...createTrackingData(trackingBaseData),
              ...(trackingCategory ? { category: trackingCategory } : {}),
            },
          }
        : {}),
    },
  );
  return data;
}

export async function generateTechnicalChallengeSuggestions(
  profile: PersonalSurveyProfileDraft,
  previousSuggestions?: string[],
) {
  const { data } = await axios.post<{ suggestions: string[] }>(
    '/personal_survey_profile/technical_challenge_suggestions',
    {
      ...profile,
      previous_suggestions: previousSuggestions,
    },
  );
  return data;
}

export async function generateAdditionalBusinessContextSuggestions(
  input: PersonalSurveyProfileInput,
  previousSuggestions: string[],
) {
  const { data } = await axios.post<{ suggestions: string[] }>(
    '/personal_survey_profile/additional_business_context_suggestions',
    {
      ...input,
      previous_suggestions: previousSuggestions,
    },
  );
  return data;
}
